import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as LocalStorage from "../../utils/localStorage";
import { FaTrash } from "react-icons/fa";
import styles from "./productsStyles.module.css";
import {
  deleteSelectedProduct,
  setSelectedProducts,
  showAddProductDivAction,
  showProductDetialsAction,
} from "../redux/actions/productsActions";
import AddNewProduct from "./addNewProduct";
import ProductDetailsComponent from "./showProductDetails";

let selectedProductsArray = [];
const ProductListSection = () => {
  const actionDispatch = useDispatch();
  const {
    data: productsData,
    selectedProducts,
    showAddProductComponent,
    showProductDetailsComponent,
  } = useSelector((state) => state.products);
  const productsListColumns = [
    { key: " ", label: "select" },
    { key: "PRODUCT NAME", label: "name" },
    { key: "UNIT SOLD", label: "unitSold" },
    { key: "IN STOCK", label: "stock" },
    { key: "EXPIRE DATE", label: "expireDate" },
    { key: " ", label: "delete" },
  ];
  const addNewProduct = () => {
    if (!showAddProductComponent) {
      actionDispatch(showAddProductDivAction(true));
    }
  };
  const showProductDetails = (productDetails) => {
    if (!showProductDetailsComponent) {
      actionDispatch(
        showProductDetialsAction({
          showDetailsComponent: true,
          showDetails: productDetails,
        })
      );
    }
  };
  const deleteSelectedProducts = () => {
    const productsToDelete = {};
    selectedProducts.forEach((product) => {
      productsToDelete[product.name] = true;
    });
    const newProductsData = productsData.products.filter(
      (product) => !productsToDelete[product.name]
    );
    LocalStorage.setLSValue("productsData", {
      ...productsData,
      products: newProductsData,
    });
    selectedProductsArray = [];
    actionDispatch(
      deleteSelectedProduct({
        data: LocalStorage.getLSValue("productsData"),
        selectedProducts: selectedProductsArray,
      })
    );
  };
  const deleteCurrentProduct = (toDeleteRow) => {
    const newProductsData = productsData.products.filter(
      (product) => product.name !== toDeleteRow.name
    );
    LocalStorage.setLSValue("productsData", {
      ...productsData,
      products: newProductsData,
    });
    actionDispatch(
      deleteSelectedProduct({
        data: LocalStorage.getLSValue("productsData"),
        selectedProducts: selectedProductsArray,
      })
    );
  };
  const selected = (event, selectedRow) => {
    if (event.currentTarget.checked) {
      selectedProductsArray.push(selectedRow);;
      actionDispatch(setSelectedProducts(selectedProductsArray));
    } else {
      const index = selectedProductsArray.some((item, index) => {
        if (JSON.stringify(item) === JSON.stringify(selectedRow)) {
          return index;
        } else {
          return -1;
        }
      });
      if (index !== -1) {
        selectedProductsArray.splice(index, 1);
        actionDispatch(setSelectedProducts(selectedProductsArray));
      }
    }
  };
  return (
    <section id={styles.productsListSection}>
      <div id={styles.productsListDiv}>
        <table className={styles.productsTable} key="productsTable">
          <thead>
            <tr className={styles.productsTableHeadingTR}>
              {productsListColumns.map((column, index) => {
                return <td key={`${column.key} ${index}`}>{column.key}</td>;
              })}
            </tr>
          </thead>
          <tbody>
            {productsData.products.map((row, index) => {
              return (
                <tr key={index} className={styles.productTableRow}>
                  {productsListColumns.map((columnData, index) => {
                    if (columnData.key !== " ") {
                      return (
                        <td
                          key={`${columnData.label} ${index}`}
                          onClick={() => showProductDetails(row)}
                        >
                          {row[columnData.label]}
                        </td>
                      );
                    } else {
                      if (columnData.label === "select") {
                        return (
                          <td key={`${columnData.label} ${index}`}>
                            <input
                              className={styles.prodCheckBox}
                              type="checkbox"
                              checked={selectedProducts.some(
                                (product) =>
                                  JSON.stringify(product) === JSON.stringify(row)
                              )}
                              onChange={(event) => selected(event, row)}
                            ></input>
                          </td>
                        );
                      } else {
                        return (
                          <td key={`${columnData.label} ${index}`}>
                            <button
                              className={
                                styles.productPageButtons +
                                " " +
                                styles.delButton
                              }
                              onClick={() => deleteCurrentProduct(row)}
                            >
                              <FaTrash />
                            </button>
                          </td>
                        );
                      }
                    }
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <button
        className={styles.productPageButtons + " " + styles.addNewProduct}
        onClick={addNewProduct}
      >
        Add New Products
      </button>
      <button
        className={styles.productPageButtons + " " + styles.delSelProd}
        onClick={deleteSelectedProducts}
      >
        Delete Selected Products
      </button>
      {showAddProductComponent && <AddNewProduct />}
      {showProductDetailsComponent && <ProductDetailsComponent />}
    </section>
  );
};

export default ProductListSection;
